export type CheckoutDraft = {
  shippingAddress?: string;
  acceptedPolicies?: boolean;
  deliveryInstructions?: string;
  savedAddressId?: string;
  savedPaymentMethodId?: string;
  requestedDeliveryWindowId?: string;
  tipCents?: number;
  applyWalletBalance?: boolean;
  promoCode?: string;
  useCashPayout?: boolean;
  guestEmail?: string;
};

const STORAGE_PREFIX = 'ninpo:checkout-draft:';

const scopeKey = (userId?: string | null) => {
  const id = String(userId || '').trim();
  return id ? id : 'guest';
};

export const readCheckoutDraft = (userId?: string | null): CheckoutDraft => {
  if (typeof window === 'undefined') return {};
  try {
    const raw = window.localStorage.getItem(`${STORAGE_PREFIX}${scopeKey(userId)}`);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as CheckoutDraft;
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
};

export const persistCheckoutDraft = (userId: string | null | undefined, patch: CheckoutDraft): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    const current = readCheckoutDraft(userId);
    const next = { ...current, ...patch };
    window.localStorage.setItem(`${STORAGE_PREFIX}${scopeKey(userId)}`, JSON.stringify(next));
    return true;
  } catch {
    return false;
  }
};

export const clearCheckoutDraft = (userId?: string | null) => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(`${STORAGE_PREFIX}${scopeKey(userId)}`);
  } catch {
    /* noop */
  }
};
